module.exports = __webpack_public_path__ + "img/mad_eye_moodys_trunk.bbe02fdb.jpg";